<template>
  <kst-table paginated view-mode
    :data="items"
  >
    <b-table-column sortable
      v-slot="{ column, row }"
      field="Date"
      :label="Catalog.Date.Label"
    >
      <kst-value ellipsis :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column sortable
      v-slot="{ row }"
      field="Type"
      :label="Catalog.Type.Label"
    >
      {{ getType(row) }}
    </b-table-column>

    <b-table-column sortable numeric
      v-slot="{ column, row }"
      field="Total"
      :label="Catalog.Total.Label"
    >
      <kst-value ellipsis :class="getClass(row)" :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>
  </kst-table>
</template>

<script>
import Catalog from "../OmzetDetailsCatalog";

export default {
  props: {
    items: Array
  },
  data: () => ({
    Catalog: Catalog
  }),
  methods: {
    getType(item) {
      if(item.Type === "Invoice"){
        return "Penjualan";
      }else{
        return "Retur";
      }
    },
    getClass(item) {
      return (parseFloat(item.Total) >= 0 ? '' : 'has-text-danger');
    }
  }
}
</script>